import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error dependency missing types
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import { getProductNameTextFromApiName } from '../../_core/common/adapters/getProductNameText';
import { getUpgradeDataFromUpgradeConfig } from '../../_core/utils/getUpgradeDataFromUpgradeConfig';
import UIContactSalesButton from '../../button/UIContactSalesButton';
import { getBannerI18nSubTitleKey, getBannerI18nTitleKey } from '../utils';
import DefaultBanner from './DefaultBanner';
import { jsx as _jsx } from "react/jsx-runtime";
export const LimitPackBannerTitle = ({
  featureTranslationKey,
  value,
  limit
}) => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: getBannerI18nTitleKey('upgrades.limitPackBanner.header', featureTranslationKey),
    options: {
      value,
      limit
    }
  });
};
export const LimitPackBannerSubtext = ({
  apiName,
  featureTranslationKey
}) => {
  const translatedProductName = getProductNameTextFromApiName(apiName);
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: getBannerI18nSubTitleKey('upgrades.limitPackBanner.subtext', featureTranslationKey),
    options: {
      productName: translatedProductName
    }
  });
};
const LimitPackBanner = ({
  upgradePoint,
  limit,
  value,
  displayThreshold,
  marginStyle,
  'data-test-id': dataTestId = 'limit-pack-banner',
  displayBannerOverride = false,
  className,
  style
}) => {
  const upgradeData = getUpgradeDataFromUpgradeConfig(upgradePoint);
  const apiNameToUse = upgradeData.apiName || UpgradeProductToApiNameMap[upgradeData.upgradeProduct];
  if (!displayBannerOverride && displayThreshold && value < displayThreshold) {
    return null;
  }
  return /*#__PURE__*/_jsx(DefaultBanner, {
    titleText: /*#__PURE__*/_jsx(LimitPackBannerTitle, {
      featureTranslationKey: upgradePoint.featureTranslationKey,
      value: value,
      limit: limit
    }),
    marginStyle: marginStyle,
    dataTestId: dataTestId,
    className: className,
    style: style,
    subtext: /*#__PURE__*/_jsx(LimitPackBannerSubtext, {
      apiName: apiNameToUse,
      featureTranslationKey: upgradePoint.featureTranslationKey
    }),
    button: /*#__PURE__*/_jsx(UIContactSalesButton, {
      apiName: apiNameToUse,
      upgradeData: upgradeData,
      use: "link",
      isUpgradePoint: true
    })
  });
};
export default LimitPackBanner;